import React, { useContext, useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import MyContext from '../ContextApi/MyContext'

export default function GeneratedTickets() {
    const { allMessages, ticketMessages } = useContext(MyContext)
    const [message, setMessage] = useState("")
    const [allTickets, setAllTickets] = useState([])
    const [editTicket, setEditTicket] = useState({})
    const user = JSON.parse(sessionStorage.getItem("User"))

    const convertToPST = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', { timeZone: 'Asia/Karachi', timeZoneName: 'short' });
    };

    const fetchTickets = async () => {
        try {
            const res = await fetch("https://capobiz-backend.vercel.app/api/auth/tickets", {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            })
            const data = await res.json()
            setAllTickets(data)
        } catch (error) {
            console.error("Error fetching tickets:", error)
            Swal.fire("Error!", "Failed to load tickets.", "error")
        }
    }

    useEffect(() => {
        fetchTickets()
        ticketMessages()
    }, [])

    const deleteTicket = async (id) => {
        const { isConfirmed } = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        })

        if (isConfirmed) {
            try {
                await fetch(`https://capobiz-backend.vercel.app/api/auth/delTicket/${id}`, { method: "DELETE" })
                Swal.fire("Deleted!", "Your ticket has been deleted.", "success")
                fetchTickets()
            } catch (error) {
                console.error("Error deleting ticket:", error)
                Swal.fire("Error!", "Something went wrong.", "error")
            }
        }
    }

    const editTicketHandler = async (id) => {
        try {
            const res = await fetch(`https://capobiz-backend.vercel.app/api/auth/getTicket/${id}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            })
            const data = await res.json()
            setEditTicket(data)
            setMessage("") // Clear message field when opening new ticket
        } catch (error) {
            console.error("Error fetching ticket details:", error)
        }
    }

    const sendMessage = async (e) => {
        e.preventDefault()
        if (!message.trim()) return;

        const userId = editTicket.userId._id
        const ticketId = editTicket._id
        const status = "User Message"

        try {
            const res = await fetch("https://capobiz-backend.vercel.app/api/auth/createMessage", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message, userId, ticketId, status })
            })

            if (res.ok) {
                ticketMessages()
                setMessage("")
                Swal.fire("Sent!", "Your message has been sent.", "success")
            }
        } catch (error) {
            console.error("Error sending message:", error)
            Swal.fire("Error!", "Failed to send message.", "error")
        }
    }

    const myTickets = allTickets
        .filter(ticket => ticket.userId._id === user._id)
        .reverse()

    return (
        <div className="container py-4 px-3">
            <h3 className="mb-4 text-center fw-bold text-black">My Tickets</h3>

            {myTickets.length === 0 ? (
                <div className="text-center py-5">
                    <p className="text-muted fs-5">No tickets found.</p>
                    <p className="text-secondary">Create a new ticket to get support.</p>
                </div>
            ) : (
                <div className="table-responsive shadow-lg rounded overflow-hidden">
                    <table className="table table-striped table-hover mb-0 align-middle">
                        <thead className="table-dark text-center text-md-start">
                            <tr>
                                <th className="ps-3">Ticket ID</th>
                                <th className="d-none d-md-table-cell">Severity</th>
                                <th className="d-none d-lg-table-cell">Status</th>
                                <th className="text-center pe-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {myTickets.map(ticket => (
                                <tr key={ticket._id}>
                                    <td className="ps-3 fw-bold text-primary">
                                        <div className="d-block d-md-none text-muted small mb-1">Ticket ID:</div>
                                        {ticket.ticketId}
                                    </td>
                                    <td className="d-none d-md-table-cell">
                                        <span className={`badge bg-${
                                            ticket.severity === 'High' ? 'danger' :
                                            ticket.severity === 'Medium' ? 'warning' : 'info'
                                        }`}>
                                            {ticket.severity}
                                        </span>
                                    </td>
                                    <td className="d-none d-lg-table-cell">
                                        <span className={`badge bg-${
                                            ticket.status === 'Open' ? 'warning' :
                                            ticket.status === 'Solved' ? 'success' : 'secondary'
                                        } text-dark`}>
                                            {ticket.status}
                                        </span>
                                    </td>
                                    <td className="text-center pe-3 py-2">
                                        <button
                                            className="btn btn-danger btn-sm px-3 me-2 mb-1"
                                            onClick={() => deleteTicket(ticket._id)}
                                        >
                                            Delete
                                        </button>
                                        <button
                                            className="btn btn-primary btn-sm px-3 mb-1"
                                            data-bs-toggle="modal"
                                            data-bs-target="#conversationModal"
                                            onClick={() => editTicketHandler(ticket._id)}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Conversation Modal - Fullscreen on Mobile */}
            <div
                className="modal fade"
                id="conversationModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="conversationModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down modal-xl">
                    <div className="modal-content rounded-0 rounded-top-4 shadow-lg">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title" id="conversationModalLabel">
                                Ticket Conversation
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body p-4">
                            {editTicket.ticketId ? (
                                <>
                                    <div className="bg-light p-4 rounded mb-4 shadow-sm">
                                        <h6 className="fw-bold text-primary mb-3">Ticket Details</h6>
                                        <p className="mb-2"><strong>Ticket ID:</strong> <span className="text-primary fw-bold">{editTicket.ticketId}</span></p>
                                        <p className="mb-2"><strong>Subject:</strong> {editTicket.subject}</p>
                                        <p className="mb-2"><strong>Severity:</strong> 
                                            <span className={`ms-2 badge bg-${
                                                editTicket.severity === 'High' ? 'danger' :
                                                editTicket.severity === 'Medium' ? 'warning' : 'info'
                                            }`}>
                                                {editTicket.severity}
                                            </span>
                                        </p>
                                        <p className="mb-2"><strong>Status:</strong> 
                                            <span className={`ms-2 badge bg-${
                                                editTicket.status === 'Open' ? 'warning' :
                                                editTicket.status === 'Solved' ? 'success' : 'secondary'
                                            } text-dark`}>
                                                {editTicket.status}
                                            </span>
                                        </p>
                                        <p className="mb-0"><strong>Original Issue:</strong><br />
                                            <span className="text-muted">{editTicket.message}</span>
                                        </p>
                                    </div>

                                    <h6 className="fw-bold text-dark mb-3">Conversation</h6>
                                    <div className="conversation-section mb-4">
                                        {allMessages
                                            .filter(msg => msg.ticketId && msg.ticketId.ticketId === editTicket.ticketId)
                                            .map(msg => (
                                                <div
                                                    key={msg._id}
                                                    className={`card mb-3 shadow-sm border-3 ${
                                                        msg.messageStatus === "Admin Message"
                                                            ? "border-primary"
                                                            : "border-success"
                                                    }`}
                                                >
                                                    <div
                                                        className={`card-header fw-bold text-white ${
                                                            msg.messageStatus === "Admin Message"
                                                                ? "bg-primary"
                                                                : "bg-success"
                                                        }`}
                                                    >
                                                        {msg.messageStatus === "Admin Message" ? "Support Team" : "You"}
                                                    </div>
                                                    <div className="card-body py-3">
                                                        <p className="mb-2 text-dark">{msg.message}</p>
                                                        <small className="text-muted">
                                                            {convertToPST(msg.createAt)}
                                                        </small>
                                                    </div>
                                                </div>
                                            ))}
                                        {allMessages.filter(msg => msg.ticketId && msg.ticketId.ticketId === editTicket.ticketId).length === 0 && (
                                            <p className="text-center text-muted">No messages yet. Start the conversation!</p>
                                        )}
                                    </div>

                                    {editTicket.status !== "Solved" && (
                                        <form onSubmit={sendMessage}>
                                            <textarea
                                                rows={5}
                                                className="form-control mb-3 shadow-sm border"
                                                placeholder="Type your reply here..."
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                required
                                            ></textarea>
                                            <div className="text-end">
                                                <button type="submit" className="btn btn-success px-5 py-2 fw-bold">
                                                    Send Message
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                    {editTicket.status === "Solved" && (
                                        <div className="alert alert-success text-center">
                                            <strong>This ticket is marked as Solved.</strong><br />
                                            You can no longer send messages.
                                        </div>
                                    )}
                                </>
                            ) : (
                                <p className="text-center text-muted">Loading conversation...</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}